var m = require('mithril');
var prop = require('mithril/stream');
var key = require('../libs/keybindings');
var Model = require('../libs/Model');
var modal = require('../layout/components/modal');
var loaders = require('../layout/components/loaders');
var treeLocation = require('../locations/treeLocation');
var flash = require('../components/flash');
var ToggleSwitch = require('../components/toggleSwitch');
var copyCustomEquipmentModal = Object.create(Model);

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});


copyCustomEquipmentModal.editDialogue = function (equipmentRecord, options) {
  copyCustomEquipmentModal.newParentLocation = prop('');
  copyCustomEquipmentModal.copyColumnBindings = prop(false);
  copyCustomEquipmentModal.isSubmitting = prop(false);
  copyCustomEquipmentModal.copiedEquipment = prop(null);
  copyCustomEquipmentModal.errors = [];
  key.setScope('modal');
  var submit = () => {
    if (copyCustomEquipmentModal.isSubmitting()) return;
    copyCustomEquipmentModal.errors = [];
    if (!copyCustomEquipmentModal.newParentLocation() || !copyCustomEquipmentModal.newParentLocation()['@rid']) {
      copyCustomEquipmentModal.errors = ['Select a destination location before copying equipment.'];
      m.redraw();
      return;
    }
    copyCustomEquipmentModal.isSubmitting(true);
    return loaders.requestWithLoader({
      loader: 'submit',
      url: `/api/v1/customequipment/${equipmentRecord['@rid'].slice(1)}/copy`,
      method: 'PUT',
      body:{ 
        location: copyCustomEquipmentModal.newParentLocation()['@rid'].slice(1),
        copyColumnBindings: copyCustomEquipmentModal.copyColumnBindings() === true
      }
    })
    .then(function (result) {
      key.unbind('enter');
      copyCustomEquipmentModal.isSubmitting(false);
      copyCustomEquipmentModal.copiedEquipment(result || null);
      options && options.submitCallback ? options.submitCallback() : '';
      modal.vm.title('Equipment Copied');
      modal.vm.buttons([
        {
          label: 'Close',
          class: '',
          func: modal.vm.close
        }
      ]);
      m.redraw();
    })
    .catch(function (error) {
      copyCustomEquipmentModal.errors = extractCopyErrors(error);
      copyCustomEquipmentModal.isSubmitting(false);
      m.redraw();
      throw error;
    });
  };
  key('enter', 'modal', submit);

  modal.vm.title('Copy Equipment: ')
  modal.vm.body = copyCustomEquipmentModal.view,
  modal.vm.buttons([
    {
      label: "Save",
      class: "btn-good",
      disabled: copyCustomEquipmentModal.isSubmitting,
      func: submit
    }
  ]);
  modal.vm.open();
}

copyCustomEquipmentModal.view = function () {
  if (copyCustomEquipmentModal.copiedEquipment()) {
    return copyCustomEquipmentModal.successView(copyCustomEquipmentModal.copiedEquipment());
  }

  return m('form', {role:'form'}, [
    m(flash, {items: copyCustomEquipmentModal.errors, bg: 'bg-red'}),
    m(treeLocation, {selectedNode: copyCustomEquipmentModal.newParentLocation}),
    m('div.mt3.ba.b--moon-gray.br2.pa3', [
      m('div.flex.items-center.justify-between.mb2', [
        m('label.f5', { for: 'copy-equipment-column-bindings' }, 'Copy point bindings'),
        m(ToggleSwitch, {
          id: 'copy-equipment-column-bindings',
          checked: copyCustomEquipmentModal.copyColumnBindings() === true,
          disabled: copyCustomEquipmentModal.isSubmitting(),
          ariaLabel: 'Copy point bindings',
          onchange: function () {
            if (copyCustomEquipmentModal.isSubmitting()) return;
            copyCustomEquipmentModal.copyColumnBindings(!copyCustomEquipmentModal.copyColumnBindings());
          }
        })
      ]),
      m('div.f6.gray', 'Copied equipment will use the same live points as the source equipment.')
    ])
  ])  
}

copyCustomEquipmentModal.successView = function (copiedEquipment) {
  var route = getEquipmentRoute(copiedEquipment);
  var name = copiedEquipment && copiedEquipment.name ? copiedEquipment.name : 'copied equipment';

  return m('div', [
    m('div.mb3', 'Copy complete.'),
    route
      ? m('a.blue.underline.pointer', {
        href: '#!' + route,
        onclick: function (event) {
          event.preventDefault();
          modal.vm.close();
          m.route.set(route);
        }
      }, 'Open ' + name)
      : m('div', 'The copied equipment was created, but no navigation target was returned.')
  ]);
}

function extractCopyErrors(error) {
  if (!error) return ['Unable to copy equipment.'];
  if (Array.isArray(error)) return error;
  if (typeof error === 'string') return [error];
  if (error.errors && Array.isArray(error.errors)) return error.errors;
  if (typeof error.message === 'string' && error.message) return [error.message];
  if (typeof error.error === 'string' && error.error) return [error.error];
  return ['Unable to copy equipment.'];
}

function getEquipmentRoute(equipmentRecord) {
  if (!equipmentRecord || !equipmentRecord['@rid'] || !equipmentRecord['@class']) return null;
  return '/equipment/' + String(equipmentRecord['@class']).toLowerCase() + '/' + String(equipmentRecord['@rid']).replace(/^#/, '');
}

module.exports = copyCustomEquipmentModal;
